import { IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import {
  Drawer,
  Box,
  Typography,
  Button,
  DrawerProps,
  SxProps,
} from '@mui/material';
import { useState } from 'react';

export const ProgressRing = ({
  value,
  total = 100,
  diameter = 140,
  color,
  content,
}: {
  value: number;
  total?: number;
  diameter?: number;
  color?: string;
  content?: string;
}) => {
  const percent = (value / total) * 100;

  const strokeWidth = diameter * 0.12;
  const radius = (diameter - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  const offset = circumference - (percent / 100) * circumference;
  const gradientId = `masteryGradient-${diameter}`;

  const strokeValue = color ? color : `url(#${gradientId})`;
  return (
    <Box
      sx={{
        width: diameter,
        height: diameter,
        position: 'relative',
      }}
    >
      <svg
        width={diameter}
        height={diameter}
        style={{ transform: 'rotate(-90deg)' }} // ✅ start from top
      >
        {/* ✅ Only define gradient if no color is passed */}
        {!color && (
          <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#667eea" />
              <stop offset="100%" stopColor="#764ba2" />
            </linearGradient>
          </defs>
        )}

        {/* background ring */}
        <circle
          cx={diameter / 2}
          cy={diameter / 2}
          r={radius}
          stroke="#eef2ff"
          strokeWidth={strokeWidth}
          fill="none"
        />
        {/* progress ring */}
        <circle
          cx={diameter / 2}
          cy={diameter / 2}
          r={radius}
          stroke={strokeValue} // dynamic
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round" // ✅ THIS gives rounded edges
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{
            transition: 'stroke-dashoffset 0.8s ease',
          }}
        />
      </svg>

      {/* CENTER CONTENT */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box display="flex" alignItems="flex-end">
          <Typography fontSize={diameter * 0.2} fontWeight={800}>
            {value}
          </Typography>
          <Typography fontSize={diameter * 0.1} color="neutral.grey">
            /
          </Typography>
          <Typography fontSize={diameter * 0.1} color="neutral.grey">
            {total}
          </Typography>
        </Box>

        {content && (
          <Typography
            fontSize={diameter * 0.06}
            color="#667eea"
            fontWeight="bold"
          >
            {content}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
